import { toBool } from '@/utils/helpers'

export const FORM_FIELD_LABEL_CLASS = 'form-field-label'

export function isEnhanceFormFieldAccessibility(settings) {
	if (!settings) return false

	return toBool(settings.enhance_field_form_accessibilityYN)
}

export function shouldShowPersistentFormFieldLabels(settings) {
	if (!settings) return false

	return isEnhanceFormFieldAccessibility(settings) || toBool(settings.expand_field_labelsYN)
}

export default isEnhanceFormFieldAccessibility
